var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2 Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-HOME-Copy-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(0.500000, 0.500000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,0 C5.14872538,0 0,5.14872538 0,11.5 C0,17.8512746 5.14872538,23 11.5,23 C17.8512746,23 23,17.8512746 23,11.5 C23,5.14872538 17.8512746,0 11.5,0 Z M11.5,1 C17.2989899,1 22,5.70101013 22,11.5 C22,17.2989899 17.2989899,22 11.5,22 C5.70101013,22 1,17.2989899 1,11.5 C1,5.70101013 5.70101013,1 11.5,1 Z",
    id: "Oval",
    fill: "#E10600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,5 C11.7454599,5 11.9496084,5.17687516 11.9919443,5.41012437 L12,5.5 L12,17.5 C12,17.7761424 11.7761424,18 11.5,18 C11.2545401,18 11.0503916,17.8231248 11.0080557,17.5898756 L11,17.5 L11,5.5 C11,5.22385763 11.2238576,5 11.5,5 Z",
    id: "Path-16",
    fill: "#15151E",
    transform: "translate(11.500000, 11.500000) scale(-1, 1) rotate(-45.000000) translate(-11.500000, -11.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,5 C11.7454599,5 11.9496084,5.17687516 11.9919443,5.41012437 L12,5.5 L12,17.5 C12,17.7761424 11.7761424,18 11.5,18 C11.2545401,18 11.0503916,17.8231248 11.0080557,17.5898756 L11,17.5 L11,5.5 C11,5.22385763 11.2238576,5 11.5,5 Z",
    id: "Path-16",
    fill: "#15151E",
    transform: "translate(11.500000, 11.500000) rotate(-45.000000) translate(-11.500000, -11.500000) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d48755f7b9f34131f91e3cb6b629bf42.svg";
export { ForwardRef as ReactComponent };